<template>
	<div id="app">
    <tooltip />
    <session-idle-modal v-if="isSessionIdle"></session-idle-modal>

    <div id="fatal_error" style="display: none; margin-top: 15px;"></div>

    <div v-show="isServiceAvailable" class="page">
  		<template v-if="isUserLoggedIn && !isVerify && !isSignUp && !isSignUpWidget && !isLearnerSignUp && !isInstitutionSignin && !isBuyUrl && !isLearnMore && !isScormDoneRendering && !isWidgetAdminVerification">
        <navigation ref="navigation"></navigation>
        <main-tour></main-tour>
        <table-of-contents-wrapper v-if="isCourseComponent && isStudentLogin"></table-of-contents-wrapper>
      </template>
      <template v-else>
        <template v-if="isVerify">
          <verify ref="verify"></verify>
        </template>
        <template v-if="isSignUp">
          <signup ref="signup"></signup>
        </template>
        <template v-if="isSignUpWidget">
          <signup-widget ref="signupwidget"></signup-widget>
        </template>
        <template v-if="isLearnerSignUp">
          <learner-signup ref="learnerSignup"></learner-signup>
        </template>
        <template v-if="isInstitutionSignin">
          <institution-signin ref="institutionSignin"></institution-signin>
        </template>
        <template v-if="isBuyUrl">
          <buy-url ref="buyUrl"></buy-url>
        </template>
        <template v-if="isLearnMore">
          <learn-more ref="learnMore"></learn-more>
        </template>
        <template v-if="isWidgetAdminVerification">
          <widget-admin-verify ref="widget-admin-verify"></widget-admin-verify>
        </template>
        <template v-if="isScormDoneRendering">
          <scorm-done ref="scormDone"></scorm-done>
        </template>
        <template v-if="!isVerify && !isSignUp && !isSignUpWidget && !isLearnerSignUp && !isInstitutionSignin && !isBuyUrl && !isLearnMore && !isScormDoneRendering && !isWidgetAdminVerification">
            <login ref="login"></login>
        </template>
      </template>

  		<notifications group="notify" position="bottom right" />

  		<div :class="isBuyUrl || isLearnMore || isLearnerSignUp ? '':'app_pg'">
  	    <router-view></router-view>
      </div>

      <div class="loading-spinner">
        <b-modal style="padding: 0px; overflow: hidden;" ref="loadingModal" ok-disabled cancel-diasbled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
          <div class="text-center" style="color: #FFF; overflow: hidden;">
            <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
          </div>
        </b-modal>
      </div>

      <div v-if="showFileUploadProgress" class="notifications vue-notification-group" style="width: 300px; bottom: 0px; right: 0px;">
        <div class="notification vue-notification success">
          <template v-for="(item, i) in uploadProgressFileList">
            <div v-if="(i !== 0)" style="border-top: solid 2px;" class="mb-1"></div>
            <div :id="item.uuid" class="mb-2">
              <span><strong>{{item.fileData.fileName}}</strong>: 0%</span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <smhandle></smhandle>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import '../assets/theme/default/sass/global.scss'
import { Login, NuNavLogin, Verify, Signup, SignupWidget, LearnerSignup, InstitutionSignin,  BuyUrl, SessionIdleModal, WidgetAdminVerify, LearnMore } from './login/components'
import { Navigation } from './navigation/components'
import { Smhandle } from './navigation/components'
import { MainTour } from './user/components'
import { ScormDone } from './course/components'
import { TableOfContentsWrapper } from './course/components'

export default {
  name: 'app',
  components: {
    Login,
    Verify,
    Signup,
    SignupWidget,
    LearnerSignup,
    InstitutionSignin,
    BuyUrl,
    LearnMore,
    WidgetAdminVerify,
    NuNavLogin,
    Navigation,
    ScormDone,
    SessionIdleModal,
    MainTour,
    TableOfContentsWrapper,
    Smhandle
  },
  data: () => {
    return {
      isUserLoggedIn: false,
      isServiceAvailable: true,
      uploadProgressFileList: [],
      showFileUploadProgress: false,
      isShowSessionTimeoutPrompt: false,
      sessionTimeoutAlertTime: 28740000,
      isVerify: (window.location.href.indexOf('verify') !== -1),
      isWidgetAdminVerification: (window.location.href.indexOf('widget/verification') !== -1),
      isSignUp: (window.location.href.indexOf('signup') !== -1),
      isSignUpWidget: (window.location.href.indexOf('widget/register') !== -1),
      isScormDoneRendering: (window.location.href.indexOf('course/scorm/done') !== -1),
      isLearnerSignUp: (window.location.href.indexOf('learnerSignup') !== -1),
      isInstitutionSignin: (window.location.href.indexOf('institutionSignin') !== -1),
      isBuyUrl: (window.location.href.indexOf('buy') !== -1),
      isLearnMore: (window.location.href.indexOf('learnMore') !== -1),
      isNuNavLogin: (window.location.host.indexOf('nunav') !== -1 || window.location.host.indexOf('competencyedu') !== -1 || window.location.host.indexOf('wsp') !== -1)
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.isSessionExpired()) {
        if (this.$route.path !== '/login') {
          this.$store.commit('LOAD_ALL_CHANNELS', [])
          this.$store.commit('LOAD_LEARNING_SPACES', [])
          let token = localStorage.getItem('token')
          if (token) {
            this.loadUserLogout()
          } else {
            this.isUserLoggedIn = false
          }
        }
      } else {
        this.isUserLoggedIn = true
      }
      // Set Current Page
      this.$store.commit('LOAD_CURRENT_PAGE', to.name)
    },
    '$route.name' (newName) {
      console.log('Component: ', this.$route.name)
    }
  },
  computed: {
    isCourseComponent () {
      if (this.$route.name === 'courseDashboard' || this.$route.name === 'courseLearn'
      || this.$route.name === 'entityDetail' || this.$route.name === 'entityLearn'
      || this.$route.name === 'entityResult' || this.$route.name === 'assessmentLearn') {
        return true
      }
      return false
    },
    isStudentLogin(){
      return (localStorage.getItem('userrole') === 'Student')
    },
    isSessionIdle () {
      if (this.$route.path === '/login') {
        return false
      }
      let isIdle = (this.isAppIdle || this.isShowSessionTimeoutPrompt)
      setTimeout(() => {
        let token = localStorage.getItem('token')
        if (token) {
          let loginTime = localStorage.getItem('loginTime')
          let currentTime = (new Date()).getTime()
          let sessionDuration = (currentTime - loginTime)
          if (!isIdle && (sessionDuration >= this.sessionTimeoutAlertTime)) {
            this.$store.commit('idleVue/IDLE_CHANGED', true)
          }
        }
      }, this.sessionTimeoutAlertTime)
      return isIdle
    }
  },
  mounted () {
    this.$root.$on('serviceAvailable', (isServiceAvailable, errorThrown) => {
      this.restoredSessionFromToken(isServiceAvailable, errorThrown)
    })
    if (this.isServiceAvailable) {
      if (this.isSessionExpired()) {
        this.isUserLoggedIn = false
        this.$store.commit('LOAD_ALL_CHANNELS', [])
        this.$store.commit('LOAD_LEARNING_SPACES', [])
      } else {
        this.isUserLoggedIn = true
      }
    }
    setTimeout(() => {
      $('#loading_wait_message').hide()
      if (this.isScormDoneRendering) {
        $('.grecaptcha-badge').hide()
      }
    }, 2000)
  },
  methods: {
    ...mapActions([
      'loadExtendSession',
      'loadLogDashboardActivity',
      'resetSelectedFactes',
      'loadCurrentPage'
    ]),
    setupUploadProgressFileList (filesToBeUploaded) {
      $.each(filesToBeUploaded, (i, item) => {
        this.uploadProgressFileList.push(item)
      })
    },
    async extendCurrentSession () {
      this.isShowSessionTimeoutPrompt = false
      this.$store.commit('idleVue/IDLE_CHANGED', false)
      let token = localStorage.getItem('token')
      await this.loadExtendSession(token)
    },
    loadUserLogout () {
      this.resetSelectedFactes()
      this.loadLogDashboardActivity({action: 'logout', page: 'logout', link: ''})
      let openId = localStorage.getItem('openId')
      localStorage.clear()
      if (openId === 'PRAGYA_TEMP_OPEN_ID_FOR_NU') {
        window.location.href = '/sso/nu'
      } else {
        this.isUserLoggedIn = false
        let currentUrl = encodeURIComponent(window.location.href)
        let host = window.location.host
        let currentUrl1 = window.location.href

        if(currentUrl1.indexOf('vue/#/login') !=-1){
            currentUrl = encodeURIComponent('https://'+host+'/vue/#/dashboard/modern')
        }
          if(host && (host.indexOf('capsicohealth') !=-1)){
            if(host.indexOf('demo.') !=-1){
              let loginUrl = 'https://genailearning-demo.capsicohealth.com/web/apps/home.jsp?returnUrl='+currentUrl
              window.location.href = loginUrl
            }else{
              let loginUrl = 'https://genailearning.capsicohealth.com/web/apps/home.jsp?returnUrl='+currentUrl
              window.location.href = loginUrl
            }
          }else{
            this.$router.replace({ path: '/login' })
          }
      }
    },
    isSessionExpired () {
      if (this.$route.path === '/signup') {
        return false
      }
      if (this.$route.path === '/learnerSignup') {
        return false
      }
      if (this.$route.path === '/institutionSignin') {
        return false
      }
      if (this.$route.path === '/buy') {
        return false
      }
      if (this.$route.path === '/learnMore') {
        return false
      }
      if (this.$route.path === '/widget/register') {
        return false
      }
      if (this.$route.path === '/widget/verification') {
        return false
      }
      if (this.$route.path === '/verify') {
        return false
      }
      if (this.$route.path === '/user/setup') {
        return false
      }
      if (this.$route.path === '/unmudl/setupExplore') {
        return false
      }
      if (this.$route.path === '/majorminor/thumbnail/googleDriveOauth') {
        return false
      }
      if (this.$route.path === '/termsAndConditions') {
        return false
      }
      let token = localStorage.getItem('token')
      if (token) {
        let loginTime = localStorage.getItem('loginTime')
        let currentTime = (new Date()).getTime()
        let currentSessionDuration = (currentTime - loginTime) / 60000
        return (currentSessionDuration > 480)
      } else {
        return true
      }
    },
    restoredSessionFromToken (isServiceAvailable, errorThrown) {
      this.isServiceAvailable = isServiceAvailable
      if (isServiceAvailable) {
        if (!this.isSessionExpired()) {
          this.isUserLoggedIn = true
          this.isServiceAvailable = isServiceAvailable
        } else {
          $('#launcher').hide()
          this.$store.commit('LOAD_ALL_CHANNELS', [])
          this.$store.commit('LOAD_LEARNING_SPACES', [])
          let token = localStorage.getItem('token')
          if (token) {
            this.loadUserLogout()
          } else {
            this.isUserLoggedIn = false

            let currentUrl = encodeURIComponent(window.location.href)
            let host = window.location.host
            let currentUrl1 = window.location.href

            if(currentUrl1.indexOf('vue/#/login') !=-1){
                currentUrl = encodeURIComponent('https://'+host+'/vue/#/dashboard/modern')
            }
            if(host && (host.indexOf('capsicohealth') !=-1)){
              if(host.indexOf('demo.') !=-1){
                let loginUrl = 'https://genailearning-demo.capsicohealth.com/web/apps/home.jsp?returnUrl='+currentUrl
                window.location.href = loginUrl
              }else{
                let loginUrl = 'https://genailearning.capsicohealth.com/web/apps/home.jsp?returnUrl='+currentUrl
                window.location.href = loginUrl
              }
            }else {
              if (this.$route.path !== '/login') {
                this.$router.replace({ path: '/login' })
              }
            }
          }
        }
      } else {
        $('#fatal_error').show()
        $('#fatal_error').html('<h1 align=center>' + errorThrown + '</h1>')
      }
    }
  }
}
</script>

<style scoped>
	#app {
	}

	.lg_blc {
    width: 30px;
    height: 30px;
    display: inline-block;
    margin: 0px 17px 0px 15px;
  }

  .status_row {
    display: flex;
    align-items: center;
    height: 45px;
    margin: 10px 0;
    min-width: 186.33px;
    font-size: 15px;
  }

  .mc_progress_bar_label {
    position: absolute;
    top: 8px;
    right: 120px;
    font-size: 14px;
    color: #FFF;
  }

  .mc_popover_progress_bar_label {
    position: absolute;
    top: 48px;
    right: 110px;
    font-size: 14px;
    color: #fff;
  }

	.legend-title {
		padding-left: 15px;
		font-size: 19px;
		font-family: robotoSlab_Light;
		margin-bottom: 17px;
	}

	.icon-progress {
		font-size: 40px;
		margin: 0 14px 0 15px;
	}

	.popover-header {
		background-color: transparent;
	}

	.performance-section {
		padding-left: 30px;
	}

	.header-title {
		color: #787878;
		font-size: 18px;
		text-align: center;
		padding: 6px 0;
	}
</style>



// WEBPACK FOOTER //
// src/app/App.vue